import { useFacilityCountsQuery } from './useFacilityCountsQuery';
import { useRoleQuery } from './useRoleQuery';
import { useRolesQuery } from './useRolesQuery';
import { useRoleUserCountsQuery } from './useRoleUserCountsQuery';

import { createMutationHook } from '~/shared/providers/api';

export interface ArchiveRolesMutationParams {
  roleIds: string[];
}

export const useCoreRolesArchiveMutation = createMutationHook(
  'settings.teamPermissions.archiveRoles',
  (params: ArchiveRolesMutationParams) => ({
    coreRolesArchive: {
      __args: {
        input: {
          roleIds: params.roleIds,
        },
      },
      successCount: true,
      failedCount: true,
      failedIds: true,
    },
  }),
  {
    invalidateQueries: [
      useRolesQuery,
      useRoleUserCountsQuery,
      useRoleQuery,
      useFacilityCountsQuery,
    ],
  },
);
